// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { Link } from "react-router-dom";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import {
  Img,
  Typeset,
  Typepad,
  DatesRange,
  BgColor2
} from "../../Partials/Typeset";
import { ThemeColors } from "../../Partials/ThemeColors";
import {
  colors,
  sizes,
  expandValue,
  breakpoints
} from "../../../helpers/theme";
import { work } from "../../../helpers/data";
import { slugify } from "../../../helpers/utils";

import { ThemeProvider } from "emotion-theming";
import InViewMonitor from "react-inview-monitor";

import p_littlebuddy from "../../../images_hd/JS/JS_littlebuddy.png";

var tinycolor = require("tinycolor2");
var $ = require("jquery");

let GridStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[2])}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: ${expandValue(sizes.space * 2)};
  }
`;
let Grid = styled("div")`
  ${GridStyles}
`;

let ImgOverlaytyles = props => css`
  margin-right: -30vw;
  padding-bottom: 5vw;
  position relative;
  pointer-events: none;
  &:before {
    position: absolute;
    content: ' ';
    top: 70%;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${props.theme.colors.white};
    background: linear-gradient(7.5deg, ${tinycolor(
      props.theme.colors.white
    ).toRgbString()} 0%, ${tinycolor(props.theme.colors.secondary)
  .lighten(20)
  .brighten(35)
  .desaturate(80)
  .toRgbString()} 100%);
  }
  img {
    position: relative;
  }
  @media (min-width: ${expandValue(breakpoints[2])}) {
    margin-right: 0;
    margin-top: -30vw;
  }
`;
let ImgOverlay = styled("div")`
  ${ImgOverlaytyles}
`;

let CardStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[3])}) {
    display: grid;
    grid-template-columns: 50% 50%;
  }
`;
let Card = styled("article")`
  ${CardStyles}
`;

// Get me only this project
let workit = work.filter(work => work.component === "WorkSmmgs");

export class CardSmmgs extends React.Component {
  render() {
    let desc = "I made this little buddy to practice Donkey Kong.";
    if (this.props.desc) {
      desc = this.props.desc;
    }
    return (
      <Card>
        <div css={{ gridColumn: "1/2" }}>
          <BgColor2 style={{ height: "100%" }}>
            <Typepad>
              <Typeset>
                <h2 style={{ marginBottom: 0 }}>
                  Say &ldquo;Hello&rdquo; to SMMGS!
                </h2>
                <h4 className="line">The Super Mega Mini Game Station</h4>

                <p className="text-lg">{desc}</p>
                <ul className="list-inline tags">
                  {workit[0].tags.map((tag, index) => (
                    <li key={"tag_" + index}>
                      <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                    </li>
                  ))}
                </ul>

                <DatesRange>In Progress</DatesRange>
              </Typeset>
            </Typepad>
          </BgColor2>
        </div>
        <div style={{ gridColumn: "2/3" }}>
          <Img>
            <img
              src={p_littlebuddy}
              alt="Little Buddy Super Mega Mini Game Station"
            />
          </Img>
        </div>
      </Card>
    );
  }
}

export class WorkSmmgs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { enableTheme: false };
  }
  enableTheme(inView) {
    //console.log("inView",inView.isIntersecting)
    this.setState({ enableTheme: true });
  }
  disableTheme(inView) {
    //console.log("inView",inView.isIntersecting)
    this.setState({ enableTheme: false });
  }

  render() {
    let hue = 357;
    let sat = 70;
    let lit = 50;

    let blendSpin = 30;

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();

    let colorBackground1 = "#370f1f";
    let colorBackground2 = "#2f060d";
    let colorBackground3 = colorBackground1;
    let colorBackground4 = colorBackground1;
    let colorBackground5 = colorBackground2;
    let colorBackground6 = colorBackground2;

    const enableTheme = this.state.enableTheme;
    let doTheDamnTheme;

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        blendSpin: 0,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };

    if (enableTheme) {
      // Set browser color
      $("meta[name=theme-color]").remove();
      $("head").append(
        '<meta name="theme-color" content="' + colorBackground2 + '">'
      );

      doTheDamnTheme = (
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
      );
    } else {
      doTheDamnTheme = "";
    }

    return (
      <ThemeProvider theme={theme}>
        <InViewMonitor
          intoViewMargin={"-50%"}
          repeatOnInView={true}
          onInView={inView => this.enableTheme(inView)}
          onNotInView={inView => this.disableTheme(inView)}
        >
          {doTheDamnTheme}

          <article data-name="smmgs">
            <Typepad pageTop>
              <Typeset>
                <Grid>
                  <div style={{ gridColumn: "4/7" }}>
                    <h2 style={{ marginBottom: 0 }}>
                      Say &ldquo;Hello&rdquo; to SMMGS!
                    </h2>
                    <h4 className="line">The Super Mega Mini Game Station</h4>
                  </div>
                  <div style={{ gridColumn: "4/7" }}>
                    <p className="text-lg">
                      I made this little buddy to practice Donkey Kong and set
                      the high score at{" "}
                      <a
                        href="https://www.quartersslc.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Quarters
                      </a>
                      .
                    </p>
                    <ul className="list-inline tags">
                      {workit[0].tags.map((tag, index) => (
                        <li key={"tag_" + index}>
                          <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                        </li>
                      ))}
                    </ul>
                    <DatesRange>In Progress</DatesRange>
                  </div>
                </Grid>
              </Typeset>
            </Typepad>

            <ImgOverlay>
              <Img>
                <img
                  src={p_littlebuddy}
                  alt="Little Buddy Super Mega Mini Game Station"
                />
              </Img>
            </ImgOverlay>
          </article>
        </InViewMonitor>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Work/Smmgs.js